import {
  MEMBER_ROLE_LABELS,
  MEMBER_ROLE_OPTIONS,
  formatPhoneEmail,
} from '../futures/futuresOrderConstants';
import { formatOptionalId } from '../deposits/onlineDepositConstants';
import { inputDateTimeToQueryApi } from '../futures/futuresRoundConstants';

export { MEMBER_ROLE_LABELS, MEMBER_ROLE_OPTIONS, formatOptionalId, formatPhoneEmail };

export const REAL_NAME_STATUS = {
  NOT_CERTIFIED: 'NOT_CERTIFIED',
  AUDITING: 'AUDITING',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
};

export const REAL_NAME_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: REAL_NAME_STATUS.NOT_CERTIFIED, label: '未認證' },
  { value: REAL_NAME_STATUS.AUDITING, label: '認證中' },
  { value: REAL_NAME_STATUS.VERIFIED, label: '已認證' },
  { value: REAL_NAME_STATUS.FAILED, label: '認證失敗' },
];

export const REAL_NAME_STATUS_LABELS = {
  NOT_CERTIFIED: '未認證',
  AUDITING: '認證中',
  VERIFIED: '已認證',
  FAILED: '認證失敗',
};

export const KYC_CERT_TYPE_OPTIONS = [
  { value: 1, label: '身份證' },
  { value: 2, label: '護照' },
  { value: 3, label: '駕照' },
];

export const KYC_CERT_TYPE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  ...KYC_CERT_TYPE_OPTIONS.map((item) => ({ value: String(item.value), label: item.label })),
];

export const KYC_CERT_TYPE_LABELS = {
  1: '身份證',
  2: '護照',
  3: '駕照',
};

export const KYC_GENDER_OPTIONS = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
];

export const KYC_GENDER_LABELS = {
  1: '男',
  2: '女',
};

export function statusCode(value) {
  if (!value) {
    return '';
  }
  return typeof value === 'string' ? value : value?.name || value?.code || String(value);
}

export function formatRealNameStatus(value) {
  const code = statusCode(value);
  return REAL_NAME_STATUS_LABELS[code] || code || '—';
}

export function formatCertType(value) {
  if (value == null || value === '') {
    return '—';
  }
  return KYC_CERT_TYPE_LABELS[value] || String(value);
}

export function formatGender(value) {
  if (value == null || value === '') {
    return '—';
  }
  return KYC_GENDER_LABELS[value] || String(value);
}

export function kycStatusClassName(status) {
  const code = statusCode(status);
  if (code === REAL_NAME_STATUS.VERIFIED) {
    return 'status-badge status-badge--enabled';
  }
  if (code === REAL_NAME_STATUS.FAILED) {
    return 'status-badge status-badge--disabled';
  }
  if (code === REAL_NAME_STATUS.AUDITING) {
    return 'status-badge status-badge--pending';
  }
  return 'status-badge';
}

export function canAuditKyc(row) {
  return statusCode(row?.realNameStatus) === REAL_NAME_STATUS.AUDITING;
}

const MAX_KYC_QUERY_DAYS = 92;

export function validateKycUpdateTimeRange(fromInput, toInput) {
  if (!fromInput && !toInput) {
    return '';
  }
  if ((fromInput && !toInput) || (!fromInput && toInput)) {
    return '更新時間起迄需同時填寫';
  }
  const fromApi = inputDateTimeToQueryApi(fromInput);
  const toApi = inputDateTimeToQueryApi(toInput);
  if (fromApi > toApi) {
    return '更新時間起不可晚於迄';
  }
  const fromDate = fromInput.slice(0, 10);
  const toDate = toInput.slice(0, 10);
  const from = new Date(`${fromDate}T00:00:00`);
  const to = new Date(`${toDate}T00:00:00`);
  const days = Math.round((to - from) / (24 * 60 * 60 * 1000));
  if (days > MAX_KYC_QUERY_DAYS) {
    return `更新時間跨度不可超過 ${MAX_KYC_QUERY_DAYS} 天`;
  }
  return '';
}

export const KYC_JOURNEY_ACTION_LABELS = {
  SUBMIT: '送審',
  APPROVE: '審核通過',
  REJECT: '審核拒絕',
  MODIFY: '後台修改',
};

export function formatKycJourneyAction(value) {
  const code = statusCode(value);
  return KYC_JOURNEY_ACTION_LABELS[code] || code || '—';
}

export function toBirthdayInput(value) {
  if (!value) {
    return '';
  }
  const text = String(value);
  return text.length >= 10 ? text.slice(0, 10) : text;
}

export function buildKycPageBody(filters) {
  const body = {};
  if (filters.roleId) {
    body.roleId = Number(filters.roleId);
  }
  if (filters.realNameStatus) {
    body.realNameStatus = filters.realNameStatus;
  }
  if (filters.memberId) {
    body.memberId = Number(filters.memberId);
  }
  if (filters.inviterId) {
    body.inviterId = Number(filters.inviterId);
  }
  if (filters.topInviterId) {
    body.topInviterId = Number(filters.topInviterId);
  }
  if (filters.phoneEmail?.trim()) {
    body.phoneEmail = filters.phoneEmail.trim();
  }
  if (filters.lastName?.trim()) {
    body.lastName = filters.lastName.trim();
  }
  if (filters.realName?.trim()) {
    body.realName = filters.realName.trim();
  }
  if (filters.identityNumber?.trim()) {
    body.identityNumber = filters.identityNumber.trim();
  }
  if (filters.certType) {
    body.certType = Number(filters.certType);
  }
  if (filters.updateTimeFromInput) {
    body.updateTimeFrom = inputDateTimeToQueryApi(filters.updateTimeFromInput);
  }
  if (filters.updateTimeToInput) {
    body.updateTimeTo = inputDateTimeToQueryApi(filters.updateTimeToInput);
  }
  return body;
}

export function resolveContact(row) {
  return formatPhoneEmail(row?.email || row?.mobile || row?.username);
}

export function resolveCountryLabel(row) {
  return row?.areaName || row?.country || '—';
}
